import React from 'react';

const SvgAdd: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22.061 22.061"
      {...props}
    >
      <g strokeLinecap="round">
        <path d="M11.031 1v20.058M21.061 11.031H1.003" />
      </g>
    </svg>
  );
};

export default SvgAdd;
